import src from "IMAGE";
export default { src, width: 25, height: 24, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
